import { Attraction, GuestBenefit } from '@/types/attraction';

export const featuredAttractions: Attraction[] = [
  {
    id: 'niederhorn',
    name: 'Niederhorn Peak',
    category: 'nature',
    distance: '15 min drive',
    duration: '2-4 hours exploration',
    location: 'Beatenberg',
    description: 'Experience breathtaking panoramic views of Lake Thun, the Bernese Alps, and the Eiger, Mönch, and Jungfrau peaks. Accessible via cable car from Beatenberg, this peak offers hiking trails, a restaurant, and stunning photo opportunities.',
    shortDescription: 'Panoramic views of Lake Thun and the Bernese Alps',
    image: '/images/local_attractions/Niederhorn_Peak.main-1000h.webp',
    images: [
      '/images/local_attractions/Niederhorn_Peak.main-1000h.webp'
    ],
    features: ['Cable car access', 'Hiking trails', 'Panoramic views', 'Restaurant', 'Photography spots'],
    guestBenefits: ['10% discount on cable car tickets', 'Free parking at cable car station', 'Complimentary trail map', 'Weather updates via hotel app'],
    seasonalAvailability: 'year-round',
    difficulty: 'easy',
    priceRange: 'medium',
    coordinates: { lat: 46.6833, lng: 7.7833 },
    website: 'https://www.niederhorn.ch',
    openingHours: 'Cable car: 8:30 AM - 5:30 PM (summer), 9:00 AM - 4:30 PM (winter)'
  },
  {
    id: 'st-beatus-caves',
    name: 'St. Beatus Caves',
    category: 'nature',
    distance: '25 min drive',
    duration: '1-2 hours cave tour',
    location: 'Interlaken',
    description: 'Among the largest cave systems in Switzerland, these limestone caves feature stunning stalactites, underground lakes, and fascinating geological formations. Named after Saint Beatus, these caves have been a site of pilgrimage for centuries.',
    shortDescription: 'Largest cave system in Switzerland with underground lakes',
    image: '/images/local_attractions/st_beatus_cave.main-1000h.webp',
    images: [
      '/images/local_attractions/st_beatus_cave.main-1000h.webp'
    ],
    features: ['Guided tours', 'Underground lake', 'Stalactites', 'Geological formations', 'Museum'],
    guestBenefits: ['Priority booking', 'Free audio guide', 'Restaurant discount', 'Hotel shuttle available'],
    seasonalAvailability: 'year-round',
    difficulty: 'easy',
    priceRange: 'medium',
    coordinates: { lat: 46.6833, lng: 7.8667 },
    website: 'https://www.beatushoehlen.ch',
    openingHours: '9:00 AM - 5:00 PM'
  },
  {
    id: 'harder-kulm',
    name: 'Harder Kulm',
    category: 'nature',
    distance: '20 min drive',
    duration: '2-3 hours scenic visit',
    location: 'Interlaken',
    description: 'Reached by historic funicular railway, Harder Kulm offers spectacular views of Interlaken, Lake Thun, and Lake Brienz. The summit features walking paths, a restaurant, and the famous Harder Kulm viewpoint.',
    shortDescription: 'Historic funicular to panoramic viewpoints',
    image: '/images/local_attractions/lake_thun_lake_brienz.main-1000h.webp',
    images: [
      '/images/local_attractions/lake_thun_lake_brienz.main-1000h.webp'
    ],
    features: ['Funicular railway', 'Panoramic views', 'Walking paths', 'Restaurant', 'Viewpoint terrace'],
    guestBenefits: ['15% off funicular tickets', 'Free hotel shuttle', 'Restaurant reservation priority', 'Weather updates'],
    seasonalAvailability: 'year-round',
    difficulty: 'easy',
    priceRange: 'medium',
    coordinates: { lat: 46.6833, lng: 7.8500 },
    website: 'https://www.harderkulm.ch',
    openingHours: 'Funicular: 8:30 AM - 6:00 PM (summer), 9:00 AM - 5:00 PM (winter)'
  },
  {
    id: 'jungfraujoch',
    name: 'Jungfraujoch - Top of Europe',
    category: 'nature',
    distance: '45 min drive',
    duration: '4-6 hours alpine adventure',
    location: 'Grindelwald',
    description: 'The highest railway station in Europe at 3,454m, offering views of the Aletsch Glacier and the surrounding peaks. Features the Ice Palace, Sphinx Observatory, and breathtaking alpine scenery.',
    shortDescription: 'Highest railway station in Europe with Ice Palace',
    image: '/images/local_attractions/jungfraujoch_top_of_europe.main-1000h.webp',
    images: [
      '/images/local_attractions/jungfraujoch_top_of_europe.main-1000h.webp'
    ],
    features: ['Highest railway station', 'Ice Palace', 'Sphinx Observatory', 'Aletsch Glacier views', 'Restaurant'],
    guestBenefits: ['Complimentary shuttle service', 'Priority booking', 'Restaurant discount', 'Weather updates'],
    seasonalAvailability: 'year-round',
    difficulty: 'moderate',
    priceRange: 'high',
    coordinates: { lat: 46.5472, lng: 7.9850 },
    website: 'https://www.jungfraujoch.ch',
    openingHours: 'Railway: 8:00 AM - 4:00 PM (summer), 9:00 AM - 3:00 PM (winter)'
  },
  {
    id: 'thun-castle',
    name: 'Thun Castle',
    category: 'culture',
    distance: '30 min drive',
    duration: '1-2 hours castle tour',
    location: 'Thun',
    description: 'Iconic medieval castle overlooking the city of Thun and Lake Thun. Features a museum with regional history, beautiful gardens, and panoramic views of the surrounding mountains.',
    shortDescription: 'Medieval castle with museum and lake views',
    image: '/images/local_attractions/4197_-_Thun_-_Schloss_Thun_over_Rathausplatz.main-1000h.webp',
    images: [
      '/images/local_attractions/4197_-_Thun_-_Schloss_Thun_over_Rathausplatz.main-1000h.webp'
    ],
    features: ['Medieval architecture', 'Regional museum', 'Beautiful gardens', 'Panoramic views', 'Historical exhibits'],
    guestBenefits: ['Free parking', 'Audio guide included', 'Garden access', 'Photo permit included'],
    seasonalAvailability: 'year-round',
    difficulty: 'easy',
    priceRange: 'low',
    coordinates: { lat: 46.7500, lng: 7.6167 },
    website: 'https://www.schlossthun.ch',
    openingHours: 'Castle: 10:00 AM - 5:00 PM, Museum: 11:00 AM - 5:00 PM'
  },
  {
    id: 'spiez-castle',
    name: 'Spiez Castle',
    category: 'culture',
    distance: '25 min drive',
    duration: '1-2 hours historic visit',
    location: 'Spiez',
    description: 'Romanesque church and picturesque location on Lake Thun. Features a historic wine cellar, beautiful gardens, and stunning lake views. One of Switzerland\'s most photographed castles.',
    shortDescription: 'Romanesque castle with wine cellar and lake views',
    image: '/images/local_attractions/Spiez,_Switzerland_Castle.main-1000h.webp',
    images: [
      '/images/local_attractions/Spiez,_Switzerland_Castle.main-1000h.webp'
    ],
    features: ['Romanesque architecture', 'Wine cellar', 'Lake views', 'Beautiful gardens', 'Historical significance'],
    guestBenefits: ['Wine tasting discount', 'Garden tour included', 'Photography spots', 'Free parking'],
    seasonalAvailability: 'year-round',
    difficulty: 'easy',
    priceRange: 'low',
    coordinates: { lat: 46.6833, lng: 7.6833 },
    website: 'https://www.spielschloss.ch',
    openingHours: '10:00 AM - 5:00 PM'
  },
  {
    id: 'schynige-platte',
    name: 'Schynige Platte',
    category: 'nature',
    distance: '35 min drive',
    duration: '3-4 hours botanical hike',
    location: 'Wilderswil',
    description: 'Historic cogwheel train takes you to an alpine botanical garden at 2,000m. Features 650+ plant species, spectacular views of the Jungfrau region, and walking trails.',
    shortDescription: 'Historic cogwheel train to alpine botanical garden',
    image: '/images/local_attractions/schynige _platte.main-1000h.webp',
    images: [
      '/images/local_attractions/schynige _platte.main-1000h.webp'
    ],
    features: ['Historic cogwheel train', 'Alpine botanical garden', 'Panoramic views', 'Walking trails', 'Restaurant'],
    guestBenefits: ['20% off train tickets', 'Free botanical garden guide', 'Priority reservations', 'Hotel shuttle service'],
    seasonalAvailability: 'summer',
    difficulty: 'easy',
    priceRange: 'medium',
    coordinates: { lat: 46.6528, lng: 7.9083 },
    website: 'https://www.schynigeplatte.ch',
    openingHours: 'Train: 8:30 AM - 5:00 PM (summer)'
  },
  {
    id: 'trummelebach-falls',
    name: 'Trümmelbach Falls',
    category: 'nature',
    distance: '40 min drive',
    duration: '2-3 hours waterfall exploration',
    location: 'Lauterbrunnen',
    description: 'UNESCO-recognized natural wonder featuring 10 glacier-fed waterfalls inside the mountain. Europe\'s largest subterranean waterfall system.',
    shortDescription: '10 glacier-fed waterfalls inside the mountain',
    image: '/images/local_attractions/trummelbach_falls.main-1000h.webp',
    images: [
      '/images/local_attractions/trummelbach_falls.main-1000h.webp'
    ],
    features: ['Underground waterfalls', 'Guided tours', 'Elevator access', 'UNESCO site', 'Restaurant'],
    guestBenefits: ['Priority booking', 'Audio guide included', 'Restaurant discount', 'Free parking'],
    seasonalAvailability: 'year-round',
    difficulty: 'easy',
    priceRange: 'medium',
    coordinates: { lat: 46.5500, lng: 7.9167 },
    website: 'https://www.truemmelbachfall.ch',
    openingHours: '9:00 AM - 5:00 PM (summer), 10:00 AM - 4:00 PM (winter)'
  },
  {
    id: 'giessbach-falls',
    name: 'Giessbach Falls',
    category: 'nature',
    distance: '30 min drive',
    duration: '2-3 hours waterfall hike',
    location: 'Brienz',
    description: '14 waterfalls cascading 500m down the mountain into Lake Brienz. Features historic Grand Hotel and scenic walking paths.',
    shortDescription: '14 waterfalls cascading 500m into Lake Brienz',
    image: '/images/local_attractions/giessbach-waterfalls-switerzland.main-1000h.webp',
    images: [
      '/images/local_attractions/giessbach-waterfalls-switerzland.main-1000h.webp'
    ],
    features: ['14 waterfalls', 'Historic Grand Hotel', 'Walking paths', 'Boat trips', 'Panoramic views'],
    guestBenefits: ['Boat trip discount', 'Hotel shuttle service', 'Priority reservations', 'Free parking'],
    seasonalAvailability: 'year-round',
    difficulty: 'easy',
    priceRange: 'medium',
    coordinates: { lat: 46.7167, lng: 8.1333 },
    website: 'https://www.giessbach.ch',
    openingHours: 'Boat trips: 9:00 AM - 6:00 PM (summer)'
  },
  {
    id: 'lake-thun-brienz',
    name: 'Lake Thun & Lake Brienz',
    category: 'nature',
    distance: '15-30 min drive',
    duration: '2-6 hours lake adventure',
    location: 'Various locations',
    description: 'Two pristine alpine lakes offering boat cruises, water sports, and scenic villages. Lake Thun features dramatic mountain backdrops while Lake Brienz offers peaceful waters.',
    shortDescription: 'Two pristine alpine lakes with boat cruises',
    image: '/images/local_attractions/lake_thun_lake_brienz.main-1000h.webp',
    images: [
      '/images/local_attractions/lake_thun_lake_brienz.main-1000h.webp'
    ],
    features: ['Boat cruises', 'Water sports', 'Swimming areas', 'Scenic villages', 'Fishing'],
    guestBenefits: ['Boat cruise discount', 'Water sports equipment rental', 'Priority booking', 'Free shuttle'],
    seasonalAvailability: 'year-round',
    difficulty: 'easy',
    priceRange: 'low',
    coordinates: { lat: 46.6833, lng: 7.7167 },
    website: 'https://www.bls.ch',
    openingHours: 'Boat services: 9:00 AM - 6:00 PM (summer)'
  },
  {
    id: 'adventure-park-interlaken',
    name: 'Interlaken Ropes Park / Seilpark',
    category: 'activity',
    distance: '25 min drive',
    duration: '3-5 hours adventure challenge',
    location: 'Interlaken',
    description: 'Thrilling adventure park with zip lines, rope courses, climbing walls, and team challenges. Perfect for families and adventure seekers.',
    shortDescription: 'Zip lines, rope courses, and adventure activities',
    image: '/images/local_attractions/ropes_park.main-1000h.webp',
    images: [
      '/images/local_attractions/ropes_park.main-1000h.webp'
    ],
    features: ['Zip lines', 'Rope courses', 'Climbing walls', 'Team challenges', 'Family activities'],
    guestBenefits: ['Priority booking', 'Group discount', 'Equipment included', 'Hotel shuttle'],
    seasonalAvailability: 'year-round',
    difficulty: 'moderate',
    priceRange: 'medium',
    coordinates: { lat: 46.6867, lng: 7.8667 },
    website: 'https://www.interlaken.ch',
    openingHours: '10:00 AM - 6:00 PM (summer), 11:00 AM - 5:00 PM (winter)'
  },
  {
    id: 'paragliding',
    name: 'Paragliding',
    category: 'activity',
    distance: '25-35 min drive',
    duration: '1-2 hours flight experience',
    location: 'Interlaken/Mürren',
    description: 'Tandem paragliding flights from scenic launch sites offering breathtaking aerial views of the Jungfrau region and alpine valleys.',
    shortDescription: 'Tandem paragliding with alpine views',
    image: '/images/local_attractions/paragliding_interlaken.main-1000h.webp',
    images: [
      '/images/local_attractions/paragliding_interlaken.main-1000h.webp'
    ],
    features: ['Tandem flights', 'Certified pilots', 'Stunning views', 'Photo service', 'Safety equipment'],
    guestBenefits: ['Priority booking', 'Photo/video package discount', 'Hotel pickup', 'Weather updates'],
    seasonalAvailability: 'summer',
    difficulty: 'moderate',
    priceRange: 'high',
    coordinates: { lat: 46.6833, lng: 7.8667 },
    website: 'https://www.paragliding.ch',
    openingHours: '9:00 AM - 6:00 PM (summer, weather dependent)'
  },
  {
    id: 'cross-country-skiing',
    name: 'Cross-Country Skiing',
    category: 'activity',
    distance: '10-20 min drive',
    duration: '2-4 hours skiing',
    location: 'Beatenberg/Habkern',
    description: 'Groomed cross-country skiing trails around Beatenberg and Habkern. Perfect for all skill levels with stunning alpine scenery.',
    shortDescription: 'Groomed trails for cross-country skiing',
    image: '/images/local_attractions/grindlewald.main-1000h.webp',
    images: [
      '/images/local_attractions/grindlewald.main-1000h.webp'
    ],
    features: ['Groomed trails', 'All skill levels', 'Scenic routes', 'Equipment rental', 'Lessons available'],
    guestBenefits: ['Free trail access', 'Equipment rental discount', 'Lessons included', 'Hotel shuttle'],
    seasonalAvailability: 'winter',
    difficulty: 'easy',
    priceRange: 'low',
    coordinates: { lat: 46.6833, lng: 7.7833 },
    website: 'https://www.beatenberg.ch',
    openingHours: 'Daily (winter season, weather dependent)'
  },
  {
    id: 'beatenberg-panorama-trail',
    name: 'Panoramic Trails Around Beatenberg',
    category: 'nature',
    distance: '5 min walk',
    duration: '1-2 hours scenic walk',
    location: 'Beatenberg',
    description: 'Scenic walking trail offering panoramic views of Lake Thun and the Bernese Alps. Easy to moderate paths with educational signposts.',
    shortDescription: 'Scenic trail with Lake Thun panoramic views',
    image: '/images/local_attractions/beatenberg_trail.main-1000h.webp',
    images: [
      '/images/local_attractions/beatenberg_trail.main-1000h.webp'
    ],
    features: ['Panoramic views', 'Educational signposts', 'Easy paths', 'Wildlife spotting', 'Photography spots'],
    guestBenefits: ['Free access', 'Trail map at hotel', 'Guided tours available', 'Rest areas'],
    seasonalAvailability: 'year-round',
    difficulty: 'easy',
    priceRange: 'free',
    coordinates: { lat: 46.6833, lng: 7.7833 },
    website: 'https://www.beatenberg.ch',
    openingHours: '24/7 access'
  },
  {
    id: 'saxeten-village',
    name: 'Saxeten Village',
    category: 'culture',
    distance: '45 min drive',
    duration: '2-4 hours village discovery',
    location: 'Saxeten',
    description: 'Hidden mountain village featuring traditional chalets, alpine meadows, and authentic Swiss mountain culture. Perfect for experiencing rural Switzerland.',
    shortDescription: 'Traditional mountain village with chalets',
    image: '/images/local_attractions/saxeten_village.main-1000h.webp',
    images: [
      '/images/local_attractions/saxeten_village.main-1000h.webp'
    ],
    features: ['Traditional chalets', 'Mountain culture', 'Alpine meadows', 'Local crafts', 'Peaceful atmosphere'],
    guestBenefits: ['Local guide included', 'Traditional meal experience', 'Photography permits', 'Hotel shuttle'],
    seasonalAvailability: 'year-round',
    difficulty: 'easy',
    priceRange: 'low',
    coordinates: { lat: 46.6333, lng: 8.2833 },
    website: 'https://www.saxeten.ch',
    openingHours: 'Village access: 24/7'
  },
];

export const guestBenefits: GuestBenefit[] = [
  {
    id: 'free-transport',
    title: 'Free Public Transport',
    description: 'Free travel on scheduled public transport within designated zones around Beatenberg and Habkern',
    icon: 'Bus',
    category: 'free',
    partner: 'Public Transport',
    value: 'Unlimited'
  },
  {
    id: 'library-access',
    title: 'Library Access',
    description: 'Free borrowing of books, DVDs, and CDs from the Beatenberg Library',
    icon: 'BookOpen',
    category: 'free',
    partner: 'Beatenberg Library',
    value: 'Free'
  },
  {
    id: 'e-bike-discount',
    title: 'E-bike Rental',
    description: '50% off e-bike rentals at Beatenberg Tourism',
    icon: 'Bike',
    category: 'discount',
    partner: 'Beatenberg Tourism',
    value: '50% off'
  },
  {
    id: 'schynige-platte-discount',
    title: 'Schynige Platte Railway',
    description: '20% off trips on the Schynige Platte Railway',
    icon: 'Train',
    category: 'discount',
    partner: 'Schynige Platte',
    value: '20% off'
  },
  {
    id: 'niesenbahn-discount',
    title: 'Niesenbahn Funicular',
    description: '20% off tickets on the Niesenbahn funicular railway',
    icon: 'Mountain',
    category: 'discount',
    partner: 'Niesenbahn',
    value: '20% off'
  },
  {
    id: 'harder-kulm-discount',
    title: 'Harder Kulm Funicular',
    description: '15% off trips on the Harder Kulm funicular railway',
    icon: 'ArrowUp',
    category: 'discount',
    partner: 'Harder Kulm',
    value: '15% off'
  },
  {
    id: 'escape-room-discount',
    title: 'Escape Rooms',
    description: '15% off Escape Rooms and Mystery Tours in Interlaken',
    icon: 'Key',
    category: 'discount',
    partner: 'Interlaken Attractions',
    value: '15% off'
  },
  {
    id: 'niederhorn-discount',
    title: 'Niederhorn Cable Car',
    description: '20% off trips on the Niederhorn gondola cable car',
    icon: 'Cable',
    category: 'discount',
    partner: 'Niederhorn',
    value: '20% off'
  },
  {
    id: 'swimming-pool-access',
    title: 'Habkern Swimming Pool',
    description: '50% off admission to the Habkern swimming pool',
    icon: 'Waves',
    category: 'discount',
    partner: 'Habkern Pool',
    value: '50% off'
  },
  {
    id: 'bus-alpin-service',
    title: 'Bus Alpin Service',
    description: '50% off Bus Alpin services when staying at least two nights',
    icon: 'Bus',
    category: 'discount',
    partner: 'Bus Alpin',
    value: '50% off'
  },
  {
    id: 'game-borrowing',
    title: 'Game Library',
    description: 'Free borrowing of games from Beatenberg Tourism',
    icon: 'Gamepad2',
    category: 'free',
    partner: 'Beatenberg Tourism',
    value: 'Free'
  }
];
